import {
  tns
} from '../../../../node_modules/tiny-slider/src/tiny-slider';

function newsContentSlider () {
  const slider = document.getElementById('js-news-content-slider');

  if (slider) {
    return tns({
      container: '#js-news-content-slider',
      mode: 'carousel',
      items: 1,
      gutter: 24,
      controls: true,
      controlsPosition: 'bottom',
      controlsText: [
        'Vorige',
        'Volgende'
      ],
      nav: false,
      responsive: {
        667: {
          items: 2
        },
        992: {
          items: 3
        }
      },
      speed: 400,
      loop: false
    });
  }
}

function addSearchSubmit () {
  const submit = document.getElementById('js-search-news-button');
  const form = document.getElementById('js-search-news-form');
  const searchBox = document.getElementById('search-news-filter');
  if (submit && form) {
    submit.addEventListener("click", function () {
      const filterUrl = getSubmitUrlFilter();
      document.location = window.location.origin + window.location.pathname + getSearchUrl(searchBox.value, filterUrl);
    });
  }
}

function addSearchFilterSubmit () {
  const radiobuttons = document.querySelectorAll('#js-search-news-form .js-filter-radiobutton');
  const searchBox = document.getElementById('search-news-filter');

  for(let i = 0; i < radiobuttons.length; i++) {
    const item = radiobuttons[i];
    item.addEventListener("click", function (e) {
      e.preventDefault();
      const filterUrl = getSubmitUrlFilter();
      document.location = window.location.origin + window.location.pathname + getSearchUrl(searchBox.value, filterUrl);
    });
  }
}

function addSearchReset () {
  const reset = document.getElementById('js-reset-news-button');
  if (reset) {
    reset.addEventListener("click", function () {
      document.location = window.location.origin + window.location.pathname;
    });
  }
}

function getSubmitUrlFilter() {
  const checked = document.querySelectorAll('#js-search-news-form input[type="radio"]:checked');
  let finalUrl = '';

  //get selected category
  const checkedCategory = Array.from(checked).filter(x => x.name === 'category');

  if (checkedCategory.length > 0) {
    finalUrl = 'cat=' + checkedCategory[0].value.toLowerCase();
  }

  return finalUrl;
}

function getSearchUrl(searchValue, filterUrl) {
  let searchUrl = '';
  if (searchValue !== '')
  {
    searchUrl = '?qn=' + searchValue;
  }
  if (filterUrl !== '')
  {
    if (searchUrl === '')
    {
      searchUrl = '?' + filterUrl;
    }
    else
    {
      searchUrl = searchUrl + '&' + filterUrl;
    }
  }
  return searchUrl;
}

if (document.getElementById('search-news-filter') !== undefined && document.getElementById('search-news-filter') !== null) {
  const filterUrl = getSubmitUrlFilter();
  document.querySelector('#search-news-filter').addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();

      document.location = window.location.origin + window.location.pathname + getSearchUrl(e.target.value, filterUrl);
    }
  });
}

addSearchSubmit();
addSearchFilterSubmit();
addSearchReset();
newsContentSlider();
